import { useHttpsCallable } from "react-firebase-hooks/functions";
import { useState } from "react";
import { functions } from "@poseidon/firebase/firebase";

export const useUpdateAdminPermissions = () => {
  const [executeCallable, loading, callableError] = useHttpsCallable(
    functions,
    "updateAdminPermissions"
  );
  const [complete, setComplete] = useState(false);
  const [funcError, setFuncError] = useState("");
  const run = async (userId: string, permissions: string[]) => {
    try {
      const result: {
        data: {
          success: boolean;
          code: string;
        };
      } = (await executeCallable({ userId, permissions })) as any;

      if (!result?.data?.success) {
        setFuncError(result?.data?.code);
        return;
      }

      setComplete(true);
    } catch (err) {
      console.error(err);
      setComplete(false);
    }
  };
  return {
    run,
    loading,
    error: callableError || funcError,
    success: !loading && !callableError && !funcError && complete,
  };
};
